import { style } from 'typestyle';
import { PAGE_CONTENT_ZINDEX } from '../../../constants';

export const contentClassName = style({
    display: 'block',
    position: 'relative',
    boxSizing: 'border-box',
    zIndex: PAGE_CONTENT_ZINDEX
});
